/* The queue's own grammar — how a segment sorts and how its line reads
 * (Tier-2 D1, ruled 2026-09-05). Kept out of the component file so the
 * surface can sort with the same rule the list groups by. */

import type { DeckQueueItem } from './types'

/** Decisions first, the bulk of the bookings last — the B6 audit's
 *  finding: the most valuable minute must not sit behind the least
 *  valuable hour. Within a section the queue's own order is kept
 *  (gates first, ties oldest-first), so a row moves only when its own
 *  stage moves. */
export const STAGE_ORDER = ['deciding', 'reconciling', 'walking', 'booking', 'settled'] as const
export type Stage = (typeof STAGE_ORDER)[number]

export const STAGE_LABEL: Record<Stage, string> = {
  deciding: 'Deciding',
  reconciling: 'Reconciling',
  walking: 'Walking',
  booking: 'Booking',
  settled: 'Settled',
}

export function stageRank(stage: string): number {
  const at = STAGE_ORDER.indexOf(stage as Stage)
  return at < 0 ? STAGE_ORDER.length : at
}

/** The sentence the officer reads. `title` is the segment sentence the
 *  assembly writes; a deck that carries none is named by its document
 *  rather than by an id the officer has never seen. */
export function rowLabel(d: DeckQueueItem): string {
  return d.title ?? d.document_name ?? 'Segment with no sentence'
}

/** The second line: its document or entering officer, and which split of it. */
export function rowSource(d: DeckQueueItem): string {
  const bits: string[] = []
  if (d.document_name) bits.push(`from ${d.document_name}`)
  else if (d.source_note) bits.push(d.source_note)
  if (d.segment_index && d.segment_count && d.segment_count > 1)
    bits.push(`part ${d.segment_index} of ${d.segment_count}`)
  return bits.join(' · ')
}
